import { EntityRepository } from '@record-it-npm/synchro-client';
import { EntityName } from 'record-it-time-common/EntityName';
import { AppEntityManagerEntityTypesByEntityName } from '../AppEntityManagerEntityTypesByEntityName';
import { ConstructionSite } from './constructionSiteTypes';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';

export class ConstructionSiteRepository extends EntityRepository<
  AppSynchronizationEnvironmentTypes,
  EntityName.ConstructionSite,
  AppEntityManagerEntityTypesByEntityName
> {
  public getByUserGroupId(userGroupId: string): Array<ConstructionSite> {
    return this.getAll().filter((cs) => cs.ownerUserGroupId === userGroupId);
  }
}
